import React, { Component, Fragment } from "react";
import { Row, Col, Button, ButtonGroup, Input, Card, Label, Table, Alert as Alert2, Badge} from "reactstrap";
import { api, filterHelper } from "../helpers";
import {
  Pager
} from "../components";
import Alert from "react-s-alert";
import _ from "lodash";
import "./Site.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const emptyWarehouseArea = {
  name: "",
  binsPerBay: null,
  numberOfBays: null,
  displayOrder: null,
  includeInTotals: true,
  collapseBins: false
};

export default class WarehouseArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editWarehouseArea: null,
      pagedList: null,
      binList: null,
      filters: [],
      sortColumn: "Name",
      sortAscending: true,
      message: null,
      messageColor: null,
      isMessageVisible: false,
      selectedWarehouseAreaId: null
    }
    this.refreshList = this.refreshList.bind(this);
    this.setPage = this.setPage.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.onChangeFilter = this.onChangeFilter.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
    this.addWarehouseArea = this.addWarehouseArea.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.isFormValid = this.isFormValid.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onSelectChange = this.onSelectChange.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.onCheckBoxChange = this.onCheckBoxChange.bind(this);
    this.collapseBin = this.collapseBin.bind(this);
    this.getAreaBays = this.getAreaBays.bind(this);
  }

  componentDidMount() {
   this.refreshList();
  }

  refreshList(sortColumn, sortAscending, filters, pageNumber) {
    const resolvedFilters = filters || this.state.filters;
    const resolvedSort = {
      sortColumn: sortColumn || this.state.sortColumn,
      sortAscending: sortAscending || this.state.sortAscending
    };
    const payload = {
      activeOnly: null,
      name: null,
      ...resolvedSort,
      ...filterHelper.filtersToObject(resolvedFilters),
      pageSize: 50,
      page:
        pageNumber ||
        (this.state.pagedList ? this.state.pagedList.pageNumber : 1)
    };
    api.post("Admin/PagedWarehouseAreas", payload).then(response => {
      if (response && response.data) {
        this.setState({
          ...resolvedSort,
          pagedList: {
            list: _.map(response.data.dataSource,
              x => { x.collapseBins = false; return x; }),
            pageNumber: response.data.page,
            pageSize: response.data.pageSize,
            totalItems: response.data.totalItems,
            totalPages: response.data.totalPages
          },
          filters: resolvedFilters,
          editWarehouseArea: null,
          message: null,
          messageColor: null,
          isMessageVisible: false
        });
      }
    });
  }

  setPage(page) {
    this.refreshList(null, null, null, page);
  }

  clearFilters() {
    const filters = [];
    this.setState({ filters: filters });
    this.refreshList(null, null, filters);
  }

  onChangeFilter(changedFilter) {
    const filters = filterHelper.getFilters(this.state.filters, changedFilter);
    this.setState({ filters: filters });
    this.refreshList(null, null, filters, 1);
  }

  onDismiss() {
    this.setState({
      isMessageVisible: !this.state.isMessageVisible,
      message: null,
      messageColor: null
    });
  }

  addWarehouseArea() {
    this.setState({
      editWarehouseArea: emptyWarehouseArea,
      message: "Number of Bays and Bins Per Bay CANNOT be changed after bins are generated",
      messageColor: "warning",
      isMessageVisible: true
    });
  }

  onInputChange(e, fieldName) {
    this.setState({
      editWarehouseArea: { ...this.state.editWarehouseArea, [fieldName]: e.target.value }
    });
  }

  onSelectChange(selection, fieldName) {
    this.setState({
      editWarehouseArea: {
        ...this.state.editWarehouseArea,
        [fieldName]: selection.target.value
      }
    });
  }

  onCheckBoxChange(fieldName) {
    this.setState({
      editWarehouseArea: {
        ...this.state.editWarehouseArea,
        [fieldName]: !this.state.editWarehouseArea[fieldName]
      }
    });
  }

  onCancel() {
    this.setState({
      editWarehouseArea: null
    });
  }

  isFormValid() {
    let warnings = [];
    if (this.state.editWarehouseArea.name === "") {
      warnings.push("Please enter a warehouse area name");
    }
    if (!this.state.editWarehouseArea.numberOfBays || this.state.editWarehouseArea.numberOfBays === "") {
      warnings.push("Please enter a number of bays");
    }
    if (!this.state.editWarehouseArea.binsPerBay || this.state.editWarehouseArea.binsPerBay === "") {
      warnings.push("Please enter bins per bays");
    }
    if (!this.state.editWarehouseArea.displayOrder || this.state.editWarehouseArea.displayOrder === "") {
      warnings.push("Please enter display order");
    }
    this.setState({
      message: warnings.length ? warnings.join(", ") : null,
      messageColor: "danger",
      isMessageVisible: true
    });

    return warnings.length === 0;
  }

  onSave() {
    if (!this.isFormValid()) return;
    let area = Object.assign({}, this.state.editWarehouseArea);
    let payload = {
      Name: area.name,
      DisplayOrder: parseInt(area.displayOrder, 10),
      NumberOfBays: parseInt(area.numberOfBays, 10),
      BinsPerBay: parseInt(area.binsPerBay, 10),
      IncludeInTotals: area.includeInTotals
    };

    if (area.id) {
      payload.Id = area.id;
    }

    api
      .post("Admin/SaveWarehouseArea", payload)
      .then(response => {
        if (response.data.success) {
          Alert.success(
            `${area.name} was ${area.id ? "updated" : "created"}.`
          );
          this.refreshList();
        } else {
          Alert.error(
            response.data.message
          );
        }
      })
      .catch(error => Alert.error("There was an error creating Area."));
  }

  onEdit(warehouseId) {
    let list = this.state.pagedList.list.slice();
    let warehouse = _.find(list, w => {
      return w.id === warehouseId;
    });

    this.setState({
      editWarehouseArea: warehouse
    });

    window.scrollTo(0, 0);
  }

  collapseBin(id) {
    var list = this.state.pagedList.list.slice();
    let item = _.find(list, x => { return x.id === id });

    this.setState({
      selectedWarehouseAreaId: id,
      pagedList: {
        ...this.state.pagedList,
        list: _.map(list, x => {
            x.collapseBins = x.id === id ? !x.collapseBins : false;
          return x;
        })
      }
    },
      () => {
        if (item.hasAllBins) {
          this.getAreaBays()
        }
      }
    )
  }

  getAreaBays(pageNumber) {
    const payload = {
      WarehouseAreaId: this.state.selectedWarehouseAreaId,
      pageSize: 5,
      page: pageNumber || 1
    }
    api.post("Admin/PagedWarehouseBins", payload).then(response => {
      if (response && response.data) {
        this.setState({
          binList: {
            list: response.data.dataSource,
            pageNumber: response.data.page,
            pageSize: response.data.pageSize,
            totalItems: response.data.totalItems,
            totalPages: response.data.totalPages
          },
        });
      }
    });
  }

  generateBins(warehouseAreaId) {
    let area = _.find(this.state.pagedList.list.slice(), x => { return x.id === warehouseAreaId });
    if (!window.confirm(`Number Of Bays and Bins Per Bays CANNOT be changed after bins are generated. Are you sure you'd like to generate bins for ${area.name}?`)) return;

    api.post("Admin/GenerateWarehouseBins", {Id: warehouseAreaId}).then(response => {
      if (response.data.success) {
        Alert.success(
          `Bins have been generated`
        );
        this.refreshList();
      } else {
        Alert.error(
          response.data.message
        );
      }
    });
  }

  render() {
    const { editWarehouseArea } = this.state;
    return (
      <div>
        <Row>
          <Col>
            <h5>Warehouse Area</h5>
          </Col>
          <Col className="mr-3">
            {this.state.editWarehouseArea ? null : (
              <Button
                size="sm"
                color="success"
                className="float-right"
                onClick={this.addWarehouseArea}
              >
                Add New Area
              </Button>
            )}
          </Col>
        </Row>

        {this.state.message ? (
          <Alert2
            color={this.state.messageColor}
            toggle={() => this.onDismiss()}
          >
            {this.state.message}
          </Alert2>
        ) : null}

        {editWarehouseArea ? (
          <Card className="p-2">
            <Row>
              <Col>
                Name:{" "}
                <Input
                  type="text"
                  name="name"
                  id="name"
                  maxLength="20"
                  onChange={e => this.onInputChange(e, "name")}
                  value={editWarehouseArea.name}
                  disabled={editWarehouseArea.id}
                />
              </Col>
              <Col>
                Number Of Bays:{" "}
                <Input
                  type="number"
                  name="numberOfBays"
                  id="numberOfBays"
                  onChange={e => this.onInputChange(e, "numberOfBays")}
                  value={editWarehouseArea.numberOfBays}
                  disabled={editWarehouseArea.hasAllBins}
                />
              </Col>
              <Col>
                Bins Per Bay:
                <Input
                  type="number"
                  name="binsPerBay"
                  id="binsPerBay"
                  onChange={e => this.onInputChange(e, "binsPerBay")}
                  value={editWarehouseArea.binsPerBay}
                  disabled={editWarehouseArea.hasAllBins}
                />
              </Col>
              <Col>
                Display:
                <Input
                  type="number"
                  name="displayOrder"
                  id="displayOrder"
                  onChange={e => this.onInputChange(e, "displayOrder")}
                  value={editWarehouseArea.displayOrder}
                />
              </Col>
              <Col className="mt-4">
                <Label for="includeInTotals" className="mr-4">
                  <input
                    type="checkbox"
                    className="mr-2"
                    id="includeInTotals"
                    name="includeInTotals"
                    checked={editWarehouseArea.includeInTotals}
                    value={editWarehouseArea.includeInTotals}
                    onClick={() => this.onCheckBoxChange("includeInTotals")}
                  />
                  Include In Total?
                </Label>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <ButtonGroup className="float-right">
                  <Button
                    size="sm"
                    color="secondary"
                    className="buttonGroupSpacing"
                    onClick={this.onCancel}
                  >
                    Cancel
                  </Button>
                  <Button
                    size="sm"
                    className="cbdmdPrimary buttonGroupSpacing"
                    onClick={() => this.onSave()}
                  >
                    {editWarehouseArea.id ? "Update" : "Save"}
                  </Button>
                </ButtonGroup>
              </Col>
            </Row>
          </Card>
        ) : null}

        <Row className="d-flex flex-row mt-2">
          <Col>
            <Table size="sm" responsive>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Number Of Bays</th>
                  <th>Bins Per Bays</th>
                  <th>Display Order</th>
                  <th>Included In Total?</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {this.state.pagedList && this.state.pagedList.list.length > 0
                  ? this.state.pagedList.list.map(warehouseArea => (
                  <Fragment>
                    <tr key={warehouseArea.id}>
                      <td>{warehouseArea.name}</td>
                      <td>{warehouseArea.numberOfBays}</td>
                      <td>{warehouseArea.binsPerBay}</td>
                      <td>{warehouseArea.displayOrder}</td>
                      <td>
                        {warehouseArea.includeInTotals ? (
                          <FontAwesomeIcon
                            icon="check-circle"
                            className="ml-1 mt-0 mb-0 mr-2 pointer  bool-icon"
                            title="Yes"
                          />
                        ) : null}
                      </td>
                        <td>
                          <ButtonGroup>
                              <Button
                                size="sm"
                                title={warehouseArea.collapseBins ? "Hide Bins" : "Show Bins"}
                                onClick={() => this.collapseBin(warehouseArea.id)}
                                className="cbdmdSuccess buttonGroupSpacing"
                              disabled={!warehouseArea.hasAllBins || this.state.editWarehouseArea}
                              >
                                <FontAwesomeIcon icon={warehouseArea.collapseBins ? "chevron-up" : "chevron-down"} />
                              </Button>
                          <Button
                            size="sm"
                            className="cbdmdPrimary buttonGroupSpacing"
                            onClick={() => this.onEdit(warehouseArea.id)}
                            disabled={this.state.editWarehouseArea}
                            title="Edit"
                          >
                            <FontAwesomeIcon
                              icon="edit"
                              className="ml-1 mt-0 mb-0 mr-1 pointer"
                              title="Edit"
                            />
                            </Button>
                            {!warehouseArea.hasAllBins && (
                              <Button
                                size="sm"
                                onClick={() => this.generateBins(warehouseArea.id)}
                                className="cbdmdPrimaryOutline buttonGroupSpacing"
                                disabled={this.state.editWarehouseArea}
                              >
                                Generate Bins
                              </Button>
                            )}
                        </ButtonGroup>
                      </td>
                      </tr>
                      {warehouseArea.collapseBins && this.state.binList && this.state.binList.list && this.state.binList.list.length > 0 &&
                        <Fragment>
                        {this.state.binList.list.map((bin, index) => (
                            <tr key={`WAB-${index}`}>
                              <td colSpan="4"></td>
                              <td><Badge>Bay:</Badge> {bin.bay}</td>
                              <td><Badge>Bin:</Badge> {bin.bin}</td>
                            </tr>
                          ))}
                        < Pager {...this.state.binList} callBack={this.getAreaBays} />
                          </Fragment>}
                   </Fragment>
                  ))
                  : 
                  <tr>
                    <td>
                      No Records available
                    </td>
                  </tr>
                  }
              </tbody>
            </Table>
            <Pager {...this.state.pagedList} callBack={this.setPage} />
          </Col>
        </Row>

      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/WarehouseArea.js